<script lang="ts">
  /**
   * Tiny pill naming a duel's vote mode (Classic / League / Rapid / Bracket)
   * with a per-mode glyph. Unknown modes render the label only (tolerant).
   */
  import { modeLabel } from '$lib/utils/duel-phase';

  let { mode }: { mode: string } = $props();

  const label = $derived(modeLabel(mode));
</script>

<span class="mode-chip" data-mode={mode} title="Duels: {label}">
  <span class="mode-chip__glyph" aria-hidden="true">
    {#if mode === 'classic'}
      <!-- Head-to-head: two opposing arrows -->
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3 8h12m0 0-4-4m4 4-4 4M21 16H9m0 0 4-4m-4 4 4 4" />
      </svg>
    {:else if mode === 'league'}
      <!-- Ballot: point-allocation bars -->
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" d="M4 6h16M4 12h11M4 18h7" />
      </svg>
    {:else if mode === 'rapid'}
      <!-- Quickfire: lightning bolt -->
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13 2 3 14h9l-1 8 10-12h-9l1-8z" />
      </svg>
    {:else if mode === 'bracket'}
      <!-- Knockout bracket tree -->
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 5h5v6H4M4 19h5v-6H4m5 3h6M15 8h5v8h-5m0-4h-3V8" />
      </svg>
    {/if}
  </span>
  {label}
</span>

<style>
  .mode-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.3em;
    font-size: 0.6875rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    padding: 0.1em 0.55em;
    border-radius: 999px;
    color: var(--purple);
    border: 1px solid rgba(147, 51, 234, 0.4);
    white-space: nowrap;
  }
  .mode-chip__glyph {
    display: inline-flex;
    align-items: center;
  }
  .mode-chip[data-mode='rapid'] {
    color: var(--pink);
    border-color: rgba(255, 45, 120, 0.4);
  }
  .mode-chip[data-mode='league'] {
    color: var(--cyan);
    border-color: rgba(0, 229, 255, 0.35);
  }
  .mode-chip[data-mode='bracket'] {
    color: var(--gold);
    border-color: rgba(255, 215, 0, 0.35);
  }
</style>
